import { useSelector } from 'react-redux'
import { useMemo } from 'react'

const useMarkets = () => {
	const markets = useSelector((state) => state.specific.markets.markets)

	const marketIdToIndexMap = useMemo(() => {
		const output = {}
		markets?.forEach((market, index) => {
			output[market._id] = index
		})
		return output
	}, [markets])

	return { markets, marketIdToIndexMap }
}

export default useMarkets
